import type { GameModule } from '../types';
import Page from './Page';

const plinko: GameModule = {
  id: 'plinko',
  displayName: 'Plinko',
  tag: 'Arcade',
  theme: {
    gradient: 'from-pink-600 to-fuchsia-600',
    emoji: '🎰',
    logo: '/games/plinko.png',
  },
  orientation: 'portrait',
  adminIcon: 'casino',
  adminTheme: {
    headerFrom: 'from-pink-900',
    headerTo: 'to-fuchsia-900',
    ring: 'focus:ring-pink-500',
    accent: 'bg-pink-600',
    accentHover: 'hover:bg-pink-500',
    dot: 'bg-pink-400',
    softBg: 'bg-pink-500/10',
    rangeAccent: 'accent-pink-500',
    badgeClasses: 'bg-pink-500/20 text-pink-300 border-pink-500/30',
  },
  Page,
};

export default plinko;
